import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "../pages/login";
import Private from "./PrivateRoute";
import Auth from "./AuthRoute";
import Dashboard from "../pages/dashboard";
import TextModeration from "../pages/textModeration";
import Accounts from "../pages/accounts";
import Channels from "../pages/channels";
import Overview from "../pages/overview";
import Users from "../pages/users";
import Chat from "../pages/chat";
import Messages from "../pages/messages";
import ImageModeration from "../pages/imageModeration";

const Routes = () => (
  <BrowserRouter basename="/">
    <Switch>
      <Route path="/" exact component={Login} />
      {/* <Private path="/accounts" exact component={Accounts} />
      <Private path="/text-moderation" exact component={TextModeration} />
      <Private path="/channels" exact component={Channels} />
      <Private path="/overview" exact component={Overview} />
      <Private path="/users" exact component={Users} />
    <Private path="/image-moderation" exact component={ImageModeration} /> */}
      <Route path="/dashboard" exact component={Dashboard} />
      <Route path="/channels/messages" exact component={Messages} />
      <Route path="/chat/:id" exact component={Chat} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
